export default __webpack_public_path__ + "static/media/calendarIcon.33a88be0.svg";